import Vue from 'vue'
import {
  ConfigProvider,
  Alert,
  Icon,
  Button,
  Popover,
  Modal,
  Divider
} from 'ant-design-vue'

Vue.use(ConfigProvider)
  .use(Alert)
  .use(Icon)
  .use(Button)
  .use(Popover)
  .use(Modal)
  .use(Divider)

Vue.prototype.$antConfirm = Modal.confirm
Vue.prototype.$antInfo = Modal.info
